import React from "react";
import "./Partners.css";
import Nav from "../Nav";
import { Link,withRouter} from "react-router-dom";



class Partners extends React.Component {
    render() {
        return (
            <div>
                <Nav/>
                <div className="row jumbotron">
          <div className="col-4 jumbotron" style={{height: '150vh'}}>
            <div className="container">
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/About">01 About Us</a></p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/Skills"> 02 Governance Structure</a></p>
              <hr style={{backgroundColor: 'black',width: '100%' }}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/Partners">03 Partners & Potential Investors</a></p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/Values"> 04 Our Core Values</a></p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
            </div>
          </div>
        <div className="col-8">
        <div class="abhead13">
        <p></p>
        </div>
        <div class="jumbotron">
        <p style={{margin: 0, fontWeight: 'bold', fontSize: '30px'}}>Partners & Potential Investors</p>
          <hr style={{margin: 0, backgroundColor: 'green'}} className="w-100"/>
          <p style={{ fontWeight: 'bold'}}>Many top local and international companies will participate in the development of the Good Morning Bamboo Eco-City, and work with Good Morning Bamboo Agro-Forestry and Investment Services to jointly develop a practical model for sustainable urbanisation.

</p>
            <div className="row">
            
                <div className="col-3">
            <img style={{width: '60%'}} src="https://i.imgur.com/eGZCPdL.jpg" alt="..."/>
                </div>
                <div className="col-3">
                <img src="https://i.imgur.com/FvRVeL8.jpg" alt="..."/>
                </div>
                <div className="col-3">
                <img style={{width: '60%'}} src="https://i.imgur.com/cyMY7NV.jpg" alt="..."/>    
                </div>
                <div className="col-3">
                <img style={{width: '100%'}} src="https://i.imgur.com/AU9WzHw.jpg" alt="..."/> 
                </div>
                <div className="col-3 mt-5">
                <img style={{width: '100%'}} src="https://i.imgur.com/3e0csZg.jpg" alt="..."/> 
                </div>
                <div className="col-3 mt-5">
                <img style={{width: '90%'}} src="https://i.imgur.com/QvOOROC.png" alt="..."/> 
                </div>
                <div className="col-3 mt-5">
                <img style={{width: '90%'}} src="https://i.imgur.com/lOEsDIY.jpg" alt="..."/> 
                </div>
                <div className="col-3 mt-5">
                <img style={{width: '60%'}} src="https://i.imgur.com/JWp2A4J.jpg" alt="..."/> 
                </div>
              
            </div>
           
          
</div>
</div>
</div>
            </div>
        )
    }
}
export default withRouter(Partners);